import {Pipe, PipeTransform} from '@angular/core';
import {SubtitlesService} from "../core";
import {UnderfloorSensorType} from "../models";

@Pipe({
    name: 'underfloorSensorType'
})
export class UnderfloorSensorTypePipe implements PipeTransform {
    constructor(
        private subtitles: SubtitlesService,
    ) {
    }

    transform(type: UnderfloorSensorType): string {
        let typeString = '';

        if (type === 'wireless') {
            typeString = this.subtitles.setSubtitle(75);
        } else if (type === 'noSensor') {
            typeString = this.subtitles.setSubtitle(4301);
        } else if (type==="NTC") {
            typeString = this.subtitles.setSubtitle( 2021);
        } else if (type === 'wired') {
            typeString = this.subtitles.setSubtitle(637);
            typeString += ' RS';
        }
        return typeString;
    }
}
